// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "table tr[data-v-27921cc6]:nth-child(2n){--bg-opacity:1;background-color:#e7e7e7;background-color:rgba(231,231,231,var(--bg-opacity))}table tr[data-v-27921cc6]:first-child{font-weight:700;font-size:1rem}table tr td[data-v-27921cc6]{padding:1rem}", ""]);
// Exports
module.exports = exports;
